import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: provider_wonde.Address.
export default class Address extends Fragment {
  declare [Type]: 'wonde/address';

  @attr('string', { defaultValue: '' })
  declare address: string;

  @attr('string', { defaultValue: '' })
  declare town: string;

  @attr('string', { defaultValue: '' })
  declare postcode: string;

  @attr('string', { defaultValue: '' })
  declare countryCode: string;

  @attr('string', { defaultValue: '' })
  declare countryName: string;
}
